import { render } from "./ModalUpdateImage.vue?vue&type=template&id=5aab9a36&scoped=true"
import script from "./ModalUpdateImage.vue?vue&type=script&lang=js"
export * from "./ModalUpdateImage.vue?vue&type=script&lang=js"

import "./ModalUpdateImage.vue?vue&type=style&index=0&id=5aab9a36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aab9a36"]])

export default __exports__